<template>
  <div>
    <div>
      <span v-if="required" class="required">*</span><span>{{ title }}</span>
    </div>
    <v-textarea hide-details outlined v-model="data"></v-textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },

    title: {
      type: String,
      default: ''
    },

    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    data: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        return val
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
